<template>
	<div
		class="p-2 mt-2 position-relative mob-align-items-start"
		:class="
			experience.parser ? 'candash-red-details-box' : 'candash-blue-details-box'
		"
	>
		<div class="d-flex align-items-start">
			<img
				class="mr-3 lapicon"
				src="../../../assets/newdesign/dashboard/expDp.svg"
				alt=""
			/>
			<img
				class="mr-2 mobicon"
				src="@/assets/mobile/dashboard/mb-expDP.svg"
				alt=""
			/>
			<div class="d-flex justify-content-between mob-w-88 w-100">
				<div class="mob-w-95 w78 text-capitalize">
					<div
						class="bold-bluetxt"
						:class="experience.designation ? '' : 'not-mention-txt'"
					>
						{{
							experience.designation ? experience.designation : "Not Mentioned"
						}}
					</div>
					<div
						:class="isLaptop ? 'mt-2' : 'mt-1'"
						class="d-flex align-items-center candash-displaytxt-grey-2 fw-500"
					>
						<div
							class="mob-maxw-43 max-w45 text-truncate"
							:class="experience.companyName ? '' : 'not-mention-txt'"
						>
							{{
								experience.companyName
									? experience.companyName
									: "Not Mentioned"
							}}
						</div>
						<div class="candash-dot ml-2 mr-2"></div>
						<div
							class="mob-maxw-43 max-w45 text-truncate caps-first"
							:class="experience.jobType ? '' : 'not-mention-txt'"
						>
							{{ experience.jobType ? experience.jobType : "Not Mentioned" }}
						</div>
						<div
							class="candash-dot ml-2 mr-2"
							v-if="experience.parser || experience.expindustry"
						></div>
						<div
							class="mob-maxw-43 max-w45 text-truncate caps-first"
							:class="experience.jobType ? '' : 'not-mention-txt'"
						>
							{{
								experience.expindustry
									? experience.expindustry
									: experience.parser
									? "Not Mentioned"
									: ""
							}}
						</div>
					</div>
					<div class="mt-2 d-flex align-items-center job-description-subfont">
						<div
							class="max-w35 mob-maxw-43 text-truncate"
							:class="experience.startDate ? '' : 'not-mention-txt'"
						>
							{{
								experience.startDate == null || experience.startDate == ""
									? "Not Mentioned"
									: formatMonthName(experience.startDate)
							}}
							-
							<template
								v-if="experience.endDate !== '' && experience.endDate !== null"
							>
								{{ formatMonthName(experience.endDate) }}
							</template>
							<template v-else> Present </template>
						</div>
						<div class="candash-line ml-4 mr-4"></div>
						<div
							class="max-w35 mob-maxw-43 text-truncate"
							:class="experience.location ? '' : 'not-mention-txt'"
						>
							{{ experience.location ? experience.location : "Not Mentioned" }}
						</div>
					</div>
				</div>
				<div class="pt-2 pr-2 laptop-ed-icons">
					<img
						@click.stop="openEdit()"
						class="mr-2 blueShadow pointer"
						src="../../../assets/newdesign/dashboard/blueEdit1.svg"
						alt=""
					/>
					<img
						@click="deleteData()"
						src="../../../assets/newdesign/dashboard/blueDelete1.svg"
						alt=""
						class="mr-2 pointer blueShadow"
					/>
					<img
						v-if="experience.parser"
						src="../../../assets/newdesign/dashboard/disableadd.svg"
						alt=""
					/>
				</div>
				<div
					class="mobile-ed-icons w-5"
					@click.stop="$emit('select-card', experience.uniqueID)"
				>
					<img src="@/assets/newbuilder/threedots.svg" alt="" />
					<div
						class="ed-box"
						v-if="selectedCard == experience.uniqueID"
						:ref="'cardopen' + experience.uniqueID"
					>
						<div
							class="ed-box-option d-flex align-items-center pl-2 pointer"
							@click.stop="openEdit()"
						>
							<img
								src="@/assets/newbuilder/ddedit.svg"
								class="mr-2"
								alt=""
							/>Edit
						</div>
						<div
							class="ed-box-option d-flex align-items-center pl-2 pointer"
							@click.stop="deleteData()"
						>
							<img
								src="@/assets/newbuilder/delete.svg"
								class="mr-2"
								alt=""
							/>Delete
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="pl-2 mob-hide-exp">
			<div
				class="candash-blackTxt text-break mt-1"
				v-if="experience.highlight.length > 0"
			>
				<ul
					class="candash-dotted-list"
					v-for="(ressp, ind) in experience.highlight.slice(
						0,
						showMoreHighlightsDesc[experience.expID]
							? experience.highlight.length
							: 1
					)"
					:key="ind + 'high'"
				>
					<li>
						{{ ressp }}
					</li>
				</ul>
			</div>
			<span
				v-if="
					experience.highlight &&
					experience.highlight.length > 1 &&
					!showMoreHighlightsDesc[experience.expID]
				"
				class="pro-theme pointer"
				@click="toggleShowMore(experience.expID)"
				>show more</span
			>
			<span
				class="pro-theme pointer"
				v-if="showMoreHighlightsDesc[experience.expID]"
				@click="toggleShowMore(experience.expID)"
				>show less</span
			>
			<div
				v-if="
					experience.highlight &&
					experience.highlight.length < 1 &&
					localCandidateInfo.experienceLevel == 'senior'
				"
				class="pink-border asp-black-txt-2 d-flex align-items-center mt-3"
			>
				<span class="asp-subtxt">Please fill the mandatory fields</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatMonthName } from "../../../controllers/dashboard/helpers.js";

export default {
	name: "ExpCard",
	data() {
		return {
			showMoreHighlightsDesc: [],
		};
	},
	mounted() {
		document.addEventListener("click", this.clickon);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.clickon);
	},
	props: {
		selectedCard: String,
		experience: Object,
		isLaptop: Boolean,
		formConfiguration: Object,
		form: Object,
	},
	computed: {
		...mapGetters("candidateVUEX", {
			localCandidateInfo: "getcandidateInfo",
		}),
	},

	methods: {
		formatMonthName(inputDate) {
			return formatMonthName(inputDate);
		},
		clickon() {
			let id = "cardopen" + this.experience.uniqueID;
			if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
				this.$emit("select-card", "");
			}
		},
		openEdit() {
			this.$emit("edit-form", {
				form: this.form,
				content: this.experience,
				id: this.experience.uniqueID,
			});
		},
		toggleShowMore(expID) {
			this.$set(
				this.showMoreHighlightsDesc,
				expID,
				!this.showMoreHighlightsDesc[expID]
			);
		},
		deleteData() {
			this.$emit("delete-data", { content: this.experience, form: this.form });
		},
	},
};
</script>

<style></style>
